import { USER_NAME } from "../../../utils/constants";
import { useReports } from "../context/ReportsContext";
import { toast } from "react-toastify";
import SuccessIcon from "../../../images/success_icon.svg"; 
import CustomToastContent from "../../../components/CustomToastContent";

const Countdown = ({ eligibility }) => {
  const { subscribeToReports } = useReports();

  const handleSubscribe = async () => {
    try {
      const response = await subscribeToReports(USER_NAME, "trial");

      if (response.status === true) {
        toast.success(
          <CustomToastContent
            heading="Subscription Successful"
            message={response.message || "Successfully subscribed to reports!"}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Failed to subscribe to reports:", error);
      toast.error(
        <CustomToastContent
          heading="Subscription Failed"
          message="Unable to subscribe to reports. Please try again."
        />,
        {
          className: "custom-error-toast",
        }
      );
    }
  };

  return (
    <div className="p-4 border border-gray-200 rounded-lg">
      <p className="text-sm mb-4">
        {eligibility.showTrialEnded
          ? `Unlock free reports with just ${5 - eligibility.orderCount} more trades in app!`
          : "Valuable insights that you don't want to miss!"}
      </p>

      <button
        onClick={() => {
          if (eligibility.showStartTrial) {
            handleSubscribe();
          }
        }}
        className={`w-full py-3 px-4 text-xs font-semibold rounded ${
          eligibility.showTrialEnded
            ? "bg-n200 text-n700"
            : "bg-swipe-button text-p400"
        }`}
        disabled={!eligibility.showStartTrial}>
        {eligibility.showTrialEnded ? "Trial ended" : "Try now"}
      </button>
    </div>
  );
};

export default Countdown;
